import { h, svgEl } from './dom';

function NavMark(): SVGSVGElement {
  return svgEl('svg',
    {
      class: 's-nav__mark',
      viewBox: '0 0 240 120',
      fill: 'none',
      stroke: 'currentColor',
      'stroke-width': 18,
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
    },
    svgEl('polyline', { points: '70,18 18,60 70,102' }),
    svgEl('line', { x1: 148, y1: 18, x2: 92, y2: 102 }),
    svgEl('polyline', { points: '170,18 222,60 170,102' }),
  );
}

export function Nav(): HTMLElement {
  return h('nav', { class: 's-nav' },
    h('a', { href: '#', 'aria-label': 'home' }, NavMark()),
    h('div', { class: 's-nav__links' },
      h('a', { href: '#work' }, 'work'),
      h('a', { href: '#stack' }, 'stack'),
      h('a', { href: '#process' }, 'process'),
    ),
    h('a', { href: '#contact', class: 's-nav__cta' }, 'START A PROJECT →'),
  );
}
